import React from "react";
import { LanguageLocaleEnum } from "../../../../client/api";
import RoundedRectangle from "../../../components/RoundedRectangle";
import StoreBanner from "../../../components/StoreBanner";
import { translate } from "../../../../config/translator";

type LeagueStatsViewProps = {
  isVisible: boolean;
  l: LanguageLocaleEnum;
};

const LeagueStatsView: React.FC<LeagueStatsViewProps> = ({ isVisible, l }) => {
  if (!isVisible) return null;
  return (
    <div>
      <RoundedRectangle
        className="rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark mb-4  w-full"
        hasBorder
        hasTitle
        titleType="upCenter"
        titleKey="statistics"
      >
        <StoreBanner border={false} message={translate("downloadUnlimited", l)} />
      </RoundedRectangle>
    </div>
  );
};

export default LeagueStatsView;
